import { SnackbarActionTypes, SnackbarStateType } from './types'

export const snackbarInitialState: SnackbarStateType = {
  open: false,
  message: '',
  severity: 'info',
  autoHideDuration: 4321,
}

export const snackbarReducer = (state = snackbarInitialState, action: any) => {
  switch (action.type) {
    case SnackbarActionTypes.OPEN_SNACKBAR:
      return { ...state, open: true, ...action.payload }

    case SnackbarActionTypes.CLOSE_SNACKBAR:
      return { open: false, message: '', severity: 'info' }

    default:
      return { ...state }
  }
}
